import React, { forwardRef, useContext } from 'react';
import styles from '../Input.module.css';
import { InputContext } from '../Input';
import { passthroughChildrenWithDisabledState } from '../__utils';

interface IconProps {
  children: React.ReactNode;
  className?: string;
}

const InputStartIcon = forwardRef<HTMLDivElement, IconProps>(
  ({ children, className }, ref) => {
    const state = useContext(InputContext);

    const processedChildren = passthroughChildrenWithDisabledState(
      children,
      state.isDisabled,
    );

    return (
      <div
        ref={ref}
        className={`
          ${styles['input-field__startIcon']} 
          ${className || ''}
        `}
        {...(state.isDisabled ? { 'data-disabled': true } : {})}
        {...(state.isInvalid ? { 'data-invalid': true } : {})}
      >
        {processedChildren}
      </div>
    );
  },
);
InputStartIcon.displayName = 'Input.StartIcon';

export default InputStartIcon;
